import { HeyDrive } from '@/models/drive.ts'

export interface Dimension {
  width: number;
  height: number;
}

export interface DrawingStyling {
  id: string;
  display: string
  target: 'text' | 'bg'
  color: string;
}

// Element types for the new HTML-based rendering
export type ElementType = 'text' | 'image' | 'rect'

export interface BaseElement {
  id: string
  type: ElementType
  position: {
    top?: number | string
    left?: number | string
    width?: number | string
    height?: number | string
  }
  style?: React.CSSProperties
}

export interface TextElement extends BaseElement {
  type: 'text'
  content: string
  fontSize: number
  fontFamily?: string // Font ID like 'poppins' or 'dancing-script'
  color?: string
  textAlign?: 'left' | 'center' | 'right'
  uppercase?: boolean
  letterSpacing?: number // in pixels
  lineHeight?: number // Line height multiplier (e.g., 1.2, 0.9)
  stylings?: string[] // Array of styling IDs
}

export interface ImageElement extends BaseElement {
  type: 'image'
  src: string
  alt?: string
  stylings?: string[] // Array of styling IDs
}

export interface RectElement extends BaseElement {
  type: 'rect'
  backgroundColor?: string
  stylings?: string[] // Array of styling IDs
}

export type TemplateElement = TextElement | ImageElement | RectElement

export interface Template {
  id: string
  background: {
    type: 'image' | 'color'
    value: string // URL for image, hex/rgb for color
  }
  stylings: DrawingStyling[] // Available stylings in the template
  elements: TemplateElement[]
}

// Legacy interfaces - kept for compatibility if needed elsewhere
export interface DrawingTemplate {
  id: string
  styles: Array<DrawingStyling>
  data: any
}

export interface InitialElementProps {
  elementId: string
  imageUrl?: string
}

export interface DrawingProject {
  styles: Array<DrawingStyling>
}

// Props for DrawingEditor component
export interface InitialCanvas {
  template: DrawingTemplate
  initialElements: Array<InitialElementProps>
}

export interface DrawingEditorProps {
  initialCanvas?: InitialCanvas
}

export interface ElementOverrides {
  elements: Array<{
    elementId: string
    imgSrc?: string
    text?: string
  }>
}

export function templateOverridesFromDrive(drive: HeyDrive): ElementOverrides {
  return {
    elements: [
      {
        elementId: 'qr-code',
        imgSrc: drive.qr_code_image!,
      },
      {
        elementId: 'names-text',
        text: drive.title!,
      },
    ]
  }
}
